import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { PwaIntegrationService } from '@df/module-pwa/pwa-integration.service';
import { Customer } from '@df/session/api/customer';
import { LocalCustomerModel } from '../../customer/customer.model.decorator';

export const isInAppCustomerGuard: CanActivateFn = async () => {
    const pwaIntegrationService = inject(PwaIntegrationService);
    const customer = inject(Customer);

    // Check if app is running in standalone mode
    if (!pwaIntegrationService?.isStandalone) {
        return false;
    }

    try {
        // Load customer model and check for loyaltyId
        const customerModel = (await customer.model.load()) as LocalCustomerModel;
        return !!customerModel?.loyaltyId;
    } catch (error) {
        console.error('Error checking customer loyalty status:', error);
        return false;
    }
};
